import React, {useEffect} from "react";
import {StandardDialogPageComponent} from "../../../components/modal/page/standard-dialog-page.component";
import {IDialogConfirmationHandler} from "../../../services/dialog/dialog.service.interface";
import {StandardDialogContentComponent} from "../../../components/modal/content/standard-dialog-content.component";
import styled from "styled-components";
import {StandardDialogHeaderComponent} from "../../../components/modal/header/standard-dialog-header.component";
import {
    PaymentStatusQueryParamValuesEnum
} from "../../../services/booking/models/payment/payment-status-query-params.enum";


const PayIframeBox = styled.iframe`
    display: block;
    flex: 1;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
`

interface PayInIframeDialogComponentProps {
    url: string;
    dialogHandler: IDialogConfirmationHandler;
}

export const PayInIframeDialogComponent: React.FC<PayInIframeDialogComponentProps> = (props) => {
    useEffect(() => {

        const eventHandler = (event: MessageEvent<any>) => {
            if(event.data?.type === "PAYMENT_FINALIZED") {
                props.dialogHandler.accept(event.data.status ?? PaymentStatusQueryParamValuesEnum.Unknown);
            }
        }

        window.addEventListener("message", eventHandler, false);

        return () => {
            window.removeEventListener(
                "message",
                eventHandler,
               false)
        }
    }, [props.dialogHandler]);


    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent dialogHandler={props.dialogHandler} closeButtonVisibility={"visible"}/>
            <StandardDialogContentComponent dialogHandler={props.dialogHandler} fullContentHeight={true}>
                <PayIframeBox src={props.url} frameBorder={0}/>
            </StandardDialogContentComponent>
        </StandardDialogPageComponent>
    )
}